module.exports = __webpack_public_path__ + "img/sbzc_24.d5451381.jpg";